<script setup lang="ts">
import { iframePost, isInIframe, redirectMethod } from '@/utils';
import { isStarNest, webviewClose } from '@/utils/starnest';
import { showToast } from 'vant';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
const router = useRouter()
const {t} = useI18n()

const redirectBack = () =>{
  redirectMethod(()=>{
    router.replace('/integral')
  })
}
</script>

<template>
  <div class="pay-status">
    <div class="status">
      <i class="pay-fail"></i>
    </div>
    <div class="text-white">{{t('Payment failed')}}</div>
    <div  class="text-gray">{{t('Please complete the payment in time in My Order-Waiting for Payment')}}</div>
    <div class="btn" @click="redirectBack()">{{t('Return')}}</div>
  </div>
</template>

<style lang="scss" scoped>

.pay-status{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  min-height: 100vh;
  background: #070B14;
  padding-top: 90px;
  .status{
    .pay-fail{
      display: block;
      width: 100px;
      height: 100px;
      background: url(../../assets/pay-fail.svg);
      background-repeat: no-repeat;
      background-size: contain;
      margin-bottom: 16px;
    }
  }
  .text-white{
    font-size: 16px;
    color: #fff;
    margin-bottom: 14px;
  }
  .text-gray{
    width: 80%;
    text-align: center;
    font-size: 14px;
    color: #9C9CAA;
    line-height: 1.6;
  }
  .btn{
    display: flex;
    width: 265px;
    padding: 12px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 12px;
    border: 1px solid #4BFCC8;
    font-size: 16px;
    color: #1CF2E4;
    margin-top: 88px;
  }
}
</style>
